import { parseBoolean } from '@gitlab/frontend-utils';
import { initVueApp } from '/builds/gitlab/gitlab-ee/app/assets/javascripts/lib/utils/vue3compat/init_vue_app.js?vue3';
import createRouter from '/builds/gitlab/gitlab-ee/app/assets/javascripts/repository/router.js?vue3';
import UploadButton from '/builds/gitlab/gitlab-ee/app/assets/javascripts/projects/details/upload_button.vue?vue3';

export const initUploadFileTrigger = () => {
  const uploadFileTriggerEl = document.querySelector('.js-upload-file-trigger');

  if (!uploadFileTriggerEl) return false;

  const {
    targetBranch,
    originalBranch,
    canPushCode,
    canPushToBranch,
    path,
    projectPath,
    fullName,
  } = uploadFileTriggerEl.dataset;

  return initVueApp({
    el: uploadFileTriggerEl,
    name: 'UploadButtonRoot',
    router: createRouter(projectPath, originalBranch, fullName),
    provide: {
      targetBranch,
      originalBranch,
      canPushCode: parseBoolean(canPushCode),
      canPushToBranch: parseBoolean(canPushToBranch),
      path,
      emptyRepo: true,
    },
    component: UploadButton,
  });
};
